<div class="zn-step-content-sections">
  <div class="zn-step-content-section zn-step-content-section--selected">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ (localizationKeyPrefix + '.Search.Title') | abpLocalization }}</h5>
          <p>{{ (localizationKeyPrefix + '.Search.Description') | abpLocalization }}</p>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-step-content-section-layout">
        <div class="zn-step-content-section-filters">
          <div class="form-control-container">
            <label class="form-label" for="standToDivideSelect">
              {{ 'Planning::Entity.Stand' | abpLocalization }}
              <span class="form-label-required">*</span>
            </label>
            <zn-single-select
              #standSelect
              id="standToDivideSelect"
              [options]="standOptions()"
              [optionsLoader]="standOptionsLoader"
              [showSearch]="true"
              [localizationResource]="localizationResource"
              [openUp]="false"
              (selectedChange)="onStandChange($event)"
            ></zn-single-select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="zn-full-height zn-step-content-section">
    <div class="zn-step-content-section-header">
      <div class="zn-step-content-section-header-inner-container">
        <div class="zn-step-content-section-titles">
          <h5>{{ 'Planning::Entity.Stand' | abpLocalization }} <zn-pill [label]="displayValue(selectedStand())"></zn-pill></h5>
        </div>
      </div>
      <hr class="zn-separator" />
    </div>
    <div class="zn-step-content-section-body">
      <div class="zn-summary">
        <section>
          <h6>{{ (localizationKeyPrefix + '.MainData.Title') | abpLocalization }}</h6>
          <div class="zn-summary-grid">
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.ForestryBase.PropertyName' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.establishment) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'Planning::Entity.Stand.StandArea' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.standArea) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'LanguageService::Stand.StandType' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.standType) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.Cycle' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.cycle) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.Rotation' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.rotation) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.ForestryBase.ForestrySituation' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.forestSituation) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'LanguageService::Stand.NearbyPopulation' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.nearbyPopulation) }}</p>
            </div>
          </div>
        </section>

        <section>
          <h6>{{ (localizationKeyPrefix + '.PlantationData.Title') | abpLocalization }}</h6>
          <div class="zn-summary-grid">
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.Plantation.PlantationDate' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.plantationDate) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'LanguageService::Stand.PlantingType' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.plantationType) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'LanguageService::Stand.GeneticMaterial' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.geneticMaterial) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'LanguageService::Stand.Species' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.species) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'LanguageService::Stand.Spacing' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.spacing) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'LanguageService::Stand.OwnPlantation' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.ownPlantation) }}</p>
            </div>
          </div>
        </section>

        <section>
          <h6>{{ (localizationKeyPrefix + '.CycleRotationData.Title') | abpLocalization }}</h6>
          <div class="zn-summary-grid">
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.ForestryBase.LandContract' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.landContract) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ (localizationKeyPrefix + '.Fields.ForestContract') | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.forestContract) }}</p>
            </div>
            <div class="zn-summary-item">
              <p class="title">{{ 'Geographic::Entity.StandCycleRotation.PropertyType' | abpLocalization }}</p>
              <p class="subtitle">{{ displayValue(selectedStandDetails()?.propertyType) }}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</div>
